import React from 'react';
import { useHealthStatus } from '../contexts/HealthStatusContext';
import { HealthStatusPill } from './HealthStatusPill';

/**
 * issue #53 / #96: 全 page 共通の footer。 楽譜解析エンジン (score-engine) の health status を
 * inline pill 1 個で表示する。 Context が null (Provider 外) のときは pending 扱い。
 *
 * issue #96: backend (Azure Functions proxy) 廃止に伴い、 旧「API」pill (backend health) は
 * 削除した。 footer は楽譜解析エンジン pill のみ。
 */
export const AppFooter: React.FC = () => {
  const status = useHealthStatus();
  const scoreEngineState = status?.scoreEngine ?? 'pending';

  return (
    <footer className="flex justify-end px-3 pt-1 pb-3 opacity-50">
      <HealthStatusPill label="楽譜解析エンジン" status={scoreEngineState} />
    </footer>
  );
};
